import React, { useContext, useEffect, useState } from "react";
import { LatencyChart } from "./LatencyChart";
import { TestsContext } from "../../contexts";
import { Stat, Box } from "../common";
import { calculateAverage } from "../../utilities";
import { Row, Col } from "react-bootstrap";
import { Location } from "../common";

export const Test = (props) => {
  let { tests } = useContext(TestsContext);
  const { index } = props;
  const [latency, setLatency] = useState(0);
  const [jitter, setJitter] = useState(0);
  const hasData = tests !== null && Array.isArray(tests.times) && Array.isArray(tests.times[index]);

  /** Initialize data and stats.
   */
  useEffect(() => {
    if (hasData) {
      // Calculate the jitter from the times data.
      let jitter = [];
      for (var n = 0; n < tests.times[index].length - 1; ++n) {
        jitter.push(Math.trunc(Math.abs(tests.times[index][n] - tests.times[index][n + 1])));
      }

      // Get the latency and jitter averages.
      setLatency(Math.trunc(calculateAverage(tests.times[index])));
      setJitter(Math.trunc(calculateAverage(jitter)));
    }
  }, [tests, index, hasData]);

  return (
    <Box>
      <Box className='p-2'>
        <Row>
          <Col className=''>
            <Location index={index}></Location>
          </Col>
          <Col className=''>
            <LatencyChart index={index}></LatencyChart>
          </Col>
          <Col className='col-3'>
            <Row>
              <Col>
                <Stat title='Latency' value={latency} />
              </Col>
              <Col>
                <Stat title='Jitter' value={jitter} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Box>
    </Box>
  );
};
